module.exports = __webpack_public_path__ + "img/cued-stroop-dark-theme.01f7e082.png";